import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import { debounce } from 'lodash';
import CheckIcon from '../../icons/check-medium';
import Announce from '../../common/announce';
import ErrorMessage from '../../common/error-message';

const CHARACTER_LIMIT = 50;
const DEBOUNCE_WAIT = 1000; // 1 second

export default class ConsortiumNameForm extends React.Component {
  static displayName = 'ConsortiumNameForm'

  static propTypes = {
    consortium: PropTypes.object.isRequired,
    currentName: PropTypes.string.isRequired,
    changeName: PropTypes.func.isRequired,
    updateConsortium: PropTypes.func.isRequired,
    updateConsortiumPending: PropTypes.bool,
    updateConsortiumSuccess: PropTypes.bool,
    updateConsortiumError: PropTypes.object
  }

  constructor (props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.saveDebounced = debounce(this.save.bind(this), DEBOUNCE_WAIT, {
      leading: false,
      trailing: true
    });
  }

  handleChange (event) {
    const name = event.target.value.slice(0, CHARACTER_LIMIT);
    this.props.changeName(name);
    this.saveDebounced(name);
  }

  save (name) {
    this.props.updateConsortium({
      id: this.props.consortium.id,
      name
    });
  }

  shouldComponentUpdate (nextProps) {
    return (
      nextProps.consortium !== this.props.consortium ||
      nextProps.currentName !== this.props.currentName ||
      nextProps.updateConsortiumPending !==
        this.props.updateConsortiumPending ||
      nextProps.updateConsortiumSuccess !==
        this.props.updateConsortiumSuccess ||
      nextProps.updateConsortiumError !== this.props.updateConsortiumError
    );
  }

  render () {
    const {
      currentName,
      updateConsortiumPending,
      updateConsortiumSuccess,
      updateConsortiumError
    } = this.props;

    return (
      <div className="ConsortiumNameForm">
        <label className="ConsortiumNameForm-label" htmlFor="consortium.name">
          {formatMessage('Edit Consortium')}
        </label>

        {(updateConsortiumPending && <Announce message="" />) || // clear, so next saving will be announced
          (updateConsortiumError && (
            <ConsortiumNameForm.Error error={updateConsortiumError} />
          )) ||
          (updateConsortiumSuccess && <ConsortiumNameForm.Saved />)}

        <input
          className="ConsortiumNameForm-input"
          id="consortium.name"
          maxLength={CHARACTER_LIMIT}
          name="name"
          onChange={this.handleChange}
          type="text"
          value={currentName}
        />
      </div>
    );
  }

  static Error ({ error }) {
    let message = error.errors[0].message;
    if (message === 'name-minLength') {
      message = formatMessage('Consortium name cannot be empty');
    }
    return (
      <div className="ConsortiumNameForm-error">
        <ErrorMessage message={message} inline />
        <Announce message={message} />
      </div>
    );
  }

  static Saved () {
    const message = formatMessage('Changes saved');
    return (
      <div className="ConsortiumNameForm-saved">
        {message}
        <CheckIcon className="ConsortiumNameForm-saved-icon" />
        <Announce message={message} />
      </div>
    );
  }
}
